export const AREA_DEFAULTS = [
  {
    name: "1",
    defaultCapacity: 5,
    defaultPrice: 250,
  },
  {
    name: "2",
    defaultCapacity: 5,
    defaultPrice: 250,
  },
  {
    name: "3",
    defaultCapacity: 5,
    defaultPrice: 300,
  },
  {
    name: "4",
    defaultCapacity: 5,
    defaultPrice: 350,
  },
  {
    name: "5",
    defaultCapacity: 5,
    defaultPrice: 300,
  },
  {
    name: "6",
    defaultCapacity: 5,
    defaultPrice: 250,
  },
  {
    name: "7",
    defaultCapacity: 5,
    defaultPrice: 250,
  },
  {
    name: "8",
    defaultCapacity: 5,
    defaultPrice: 300,
  },
  {
    name: "9",
    defaultCapacity: 5,
    defaultPrice: 325,
  },
  {
    name: "10",
    defaultCapacity: 5,
    defaultPrice: 300,
  },
  {
    name: "11",
    defaultCapacity: 50,
    defaultPrice: 50,
  },
  {
    name: "12",
    defaultCapacity: 25,
    defaultPrice: 50,
  },
  {
    name: "13",
    defaultCapacity: 10,
    defaultPrice: 50,
  },
  {
    name: "14",
    defaultCapacity: 25,
    defaultPrice: 30,
  },
  {
    name: "15",
    defaultCapacity: 10,
    defaultPrice: 20,
  },
  {
    name: "16",
    defaultCapacity: 10,
    defaultPrice: 20,
  },
  {
    name: "17",
    defaultCapacity: 60,
    defaultPrice: 20,
  },
  {
    name: "18",
    defaultCapacity: 75,
    defaultPrice: 30,
  },
  {
    name: "19",
    defaultCapacity: 50,
    defaultPrice: 150,
  },
  {
    name: "20",
    defaultCapacity: 75,
    defaultPrice: 30,
  },
  {
    name: "21",
    defaultCapacity: 60,
    defaultPrice: 20,
  },
  {
    name: "22",
    defaultCapacity: 10,
    defaultPrice: 20,
  },
  {
    name: "23",
    defaultCapacity: 10,
    defaultPrice: 20,
  },
  {
    name: "24",
    defaultCapacity: 25,
    defaultPrice: 30,
  },
  {
    name: "25",
    defaultCapacity: 10,
    defaultPrice: 30,
  },
  {
    name: "26",
    defaultCapacity: 25,
    defaultPrice: 50,
  },
  {
    name: "27",
    defaultCapacity: 50,
    defaultPrice: 30,
  },
  {
    name: "28",
    defaultCapacity: 10,
    defaultPrice: 110,
  },
  {
    name: "29",
    defaultCapacity: 20,
    defaultPrice: 130,
  },
  {
    name: "30",
    defaultCapacity: 10,
    defaultPrice: 425,
  },
  {
    name: "31",
    defaultCapacity: 20,
    defaultPrice: 130,
  },
  {
    name: "32",
    defaultCapacity: 10,
    defaultPrice: 110,
  },
  {
    name: "33",
    defaultCapacity: 10,
    defaultPrice: 110,
  },
  {
    name: "34",
    defaultCapacity: 50,
    defaultPrice: 110,
  },
  {
    name: "35",
    defaultCapacity: 70,
    defaultPrice: 125,
  },
  {
    name: "36",
    defaultCapacity: 70,
    defaultPrice: 125,
  },
  {
    name: "37",
    defaultCapacity: 50,
    defaultPrice: 110,
  },
  {
    name: "38",
    defaultCapacity: 10,
    defaultPrice: 110,
  },
  {
    name: "39",
    defaultCapacity: 10,
    defaultPrice: 110,
  },
  {
    name: "40",
    defaultCapacity: 20,
    defaultPrice: 130,
  },
  {
    name: "41",
    defaultCapacity: 10,
    defaultPrice: 425,
  },
  {
    name: "42",
    defaultCapacity: 20,
    defaultPrice: 130,
  },
  {
    name: "43",
    defaultCapacity: 25,
    defaultPrice: 30,
  },
  {
    name: "44",
    defaultCapacity: 50,
    defaultPrice: 100,
  },
  {
    name: "45",
    defaultCapacity: 50,
    defaultPrice: 100,
  },
  {
    name: "46",
    defaultCapacity: 25,
    defaultPrice: 30,
  },
  {
    name: "47",
    defaultCapacity: 20,
    defaultPrice: 20,
  },
  {
    name: "48",
    defaultCapacity: 20,
    defaultPrice: 95,
  },
  {
    name: "49",
    defaultCapacity: 20,
    defaultPrice: 95,
  },
  {
    name: "50",
    defaultCapacity: 20,
    defaultPrice: 20,
  },
  {
    name: "A",
    defaultCapacity: 30,
    defaultPrice: 20,
  },
  {
    name: "B",
    defaultCapacity: 20,
    defaultPrice: 20,
  },
  {
    name: "C",
    defaultCapacity: 30,
    defaultPrice: 20,
  },
  {
    name: "D",
    defaultCapacity: 20,
    defaultPrice: 20,
  },
  {
    name: "Floor",
    defaultCapacity: 100,
    defaultPrice: 20,
  },
];
